export const ToolsetIcon = ({ ...props }) => (
  <svg
    version="1.0"
    xmlns="http://www.w3.org/2000/svg"
    width="512.000000pt"
    height="512.000000pt"
    viewBox="0 0 512.000000 512.000000"
    preserveAspectRatio="xMidYMid meet"
    {...props}
  >
    <g
      transform="translate(0.000000,512.000000) scale(0.100000,-0.100000)"
      fill="#000000"
      stroke="none"
    >
      <path
        d="M626 4789 c-62 -15 -153 -68 -197 -116 -22 -24 -55 -74 -72 -111
 l-32 -67 -3 -943 -2 -942 24 -25 c33 -33 79 -33 111 0 l25 24 0 912 c0 687 3
 922 12 953 16 55 99 138 154 154 28 8 129 12 313 12 l272 0 24 25 c16 15 25
 36 25 55 0 19 -9 40 -25 55 l-24 25 -283 -1 c-156 -1 -300 -5 -322 -10z"
      />
      <path
        d="M1465 4776 c-33 -33 -33 -79 0 -111 l24 -25 1472 0 c1126 0 1481 -3
 1513 -12 55 -16 138 -99 154 -154 9 -31 12 -266 12 -953 l0 -912 25 -24 c32
 -33 78 -33 111 0 l24 25 -2 942 -3 943 -32 67 c-44 93 -100 151 -191 196 l-76
 37 -1503 3 -1504 2 -24 -24z"
      />
      <path
        d="M1825 4443 c-46 -23 -93 -59 -136 -103 -224 -227 -222 -584 2 -813
 l69 -70 0 -414 c0 -424 1 -441 39 -470 26 -20 70 -15 96 12 l25 24 0 464 0
 465 -22 20 c-149 131 -187 188 -210 310 -22 120 25 273 111 357 l41 39 0 -97
 c0 -65 5 -107 14 -125 8 -15 55 -66 104 -114 122 -120 123 -120 256 12 l101
 99 5 113 5 113 42 -44 c123 -131 148 -344 57 -498 -22 -38 -44 -61 -150 -160
 l-34 -31 0 -461 0 -462 25 -24 c15 -16 36 -25 55 -25 19 0 40 9 55 25 l25 24
 0 426 0 426 58 53 c65 61 113 136 150 234 22 58 26 82 26 187 0 105 -4 129
 -26 187 -56 149 -156 265 -282 327 -73 36 -104 39 -137 12 -23 -19 -24 -25
 -27 -184 l-3 -164 -40 -39 -39 -38 -40 39 -40 39 0 158 c0 155 -1 159 -25 183
 -33 34 -66 31 -150 -12z"
      />
      <path
        d="M2907 4458 c-16 -17 -34 -71 -66 -203 l-44 -181 41 -124 42 -125 0
 -608 0 -608 25 -24 c15 -16 36 -25 55 -25 19 0 40 9 55 25 l25 24 0 576 0 575
 80 0 80 0 0 -575 0 -576 25 -24 c32 -33 78 -33 110 0 l25 24 0 608 0 608 42
 125 41 124 -44 181 c-32 132 -50 186 -66 203 -21 21 -28 22 -213 22 -185 0
 -192 -1 -213 -22z m340 -256 l30 -118 -27 -79 -27 -80 -103 0 -103 0 -27 80
 -27 79 30 118 29 118 98 0 98 0 29 -118z"
      />
      <path
        d="M3722 4473 c-7 -3 -19 -18 -27 -33 -13 -24 -15 -98 -15 -447 0 -406
 -1 -419 -20 -431 -11 -6 -29 -30 -40 -52 -19 -37 -20 -57 -20 -460 0 -350 2
 -426 15 -449 24 -48 81 -56 120 -16 l25 24 0 416 0 415 240 0 240 0 0 -405 c0
 -337 2 -411 15 -434 24 -48 81 -56 120 -16 l25 24 0 432 c0 468 -1 475 -56
 518 l-24 19 0 302 c0 193 -4 308 -11 321 -12 24 -520 279 -552 278 -12 0 -28
 -3 -35 -6z m438 -618 l0 -255 -160 0 -160 0 0 335 0 335 160 -80 160 -80 0
 -255z"
      />
      <path
        d="M1002 4387 c-17 -8 -60 -83 -153 -269 l-129 -258 0 -625 0 -626 25
 -24 c32 -33 78 -33 110 0 l25 24 0 605 0 606 77 155 c43 85 80 155 83 155 3 0
 40 -70 83 -155 l77 -155 0 -606 0 -605 25 -24 c15 -16 36 -25 55 -25 19 0 40
 9 55 25 l25 24 0 626 0 625 -129 258 c-103 205 -134 260 -155 270 -32 14 -44
 14 -74 -1z"
      />
      <path
        d="M320 2387 c-49 -16 -133 -102 -148 -153 -8 -26 -12 -112 -12 -233 0
 -190 0 -192 25 -216 l24 -25 1871 0 1871 0 24 25 c16 15 25 36 25 55 0 19 -9
 40 -25 55 l-24 25 -1816 0 -1815 0 0 135 c0 131 1 137 25 160 l24 25 2191 0
 2191 0 24 -25 c24 -23 25 -29 25 -160 l0 -135 -295 0 -296 0 -24 -25 c-33 -32
 -33 -78 0 -110 l24 -25 351 0 351 0 24 25 c25 24 25 26 25 216 0 121 -4 207
 -12 233 -16 55 -99 138 -154 154 -57 17 -4421 16 -4474 -1z"
      />
      <path
        d="M184 1575 l-25 -25 3 -463 3 -463 37 -76 c45 -91 103 -147 196 -191
 l67 -32 302 -3 303 -3 25 25 c33 33 33 79 0 111 l-24 25 -272 0 c-184 0 -285
 4 -313 12 -55 16 -138 99 -154 154 -9 30 -12 163 -12 473 l0 432 -25 24 c-32
 33 -78 33 -111 0z"
      />
      <path
        d="M4825 1575 l-25 -24 0 -432 c0 -310 -3 -443 -12 -473 -16 -55 -99
 -138 -154 -154 -32 -9 -421 -12 -1673 -12 l-1632 0 -24 -25 c-33 -32 -33 -78
 0 -111 l24 -24 1663 2 1663 3 67 32 c93 44 151 100 196 191 l37 76 3 463 3
 463 -25 25 c-33 33 -79 33 -111 0z"
      />
      <path
        d="M2105 1495 c-16 -15 -25 -36 -25 -55 0 -19 9 -40 25 -55 l24 -25 431
 0 431 0 24 25 c16 15 25 36 25 55 0 19 -9 40 -25 55 l-24 25 -431 0 -431 0
 -24 -25z"
      />
    </g>
  </svg>
);
